import { useEffect, useRef, useState } from 'react';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { MetadataAdd, Metadataupdate, Partner_list } from "../../api/api";
import dropdownArrow from '../../assets/images/dropdown-arrow.svg';
import Groupicon from "../../assets/svg/partitioncontent/blueVideoImg.svg";
import expand from "../../assets/svg/partitioncontent/open_in_full.svg";
import check from "../../assets/images/star_checked.svg";
import uncheck from "../../assets/svg/partitioncontent/starIcon.svg";
import { posterimage } from '../../service/commonFunc';
import { ContentGroup } from "../../service/Constant";
import DynamicMultiSelect from '../multiselect/MultiSelect';
import './metastyle.scss';
import { Link } from 'react-router-dom';
import appStore from '../../Config/Store/appStore';
import { toJS } from 'mobx';
import TimePicker from 'react-time-picker';
import { observer } from 'mobx-react';

const MetaDataView = observer(({ videoMetadata, closepartition, assetdetail, programVideos, databymeta }) => {
  const AssetPartnerDetail = JSON.parse(localStorage.getItem("AssetPartnerDetail"));
  const [videodata, setVideodata] = useState(videoMetadata)
  const [metadata, setMetadata] = useState(videodata?.metadata);
  const state = useSelector((state) => state);
  const genre = state?.GenreList?.data;
  const language = state?.AudioLanguageList?.data;
  const Themes = state?.ThemesList?.data;
  const Category = state?.CategoriesList?.data;
  const Ratings = state?.MaturityList?.data;
  const Territorys = state?.CountryList?.data?.data;
  const [partnerOption, setPartnerOptions] = useState([]);
  const [territoryOption, setTerritoryOption] = useState([]);
  const [categoryOptions, setCategoryOption] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [themeList, setThemeList] = useState([]);
  const [ratingList, setRatingList] = useState([]);
  const [gernreList, setGenreList] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
  const [selectedThemeIds, setSelectedThemeIds] = useState([]);
  const [selectedLanguageIds, setSelectedLanguageIds] = useState([]);
  const [selectedGenreIds, setSelectedGenreIds] = useState([]);
  const [selectedTerritoryIds, setSelectedTerritoryIds] = useState([]);

  // State for controlling dropdown visibility
  const [isContentGroupOpen, setIsContentGroupOpen] = useState(false);
  const [isOriginalLanguageOpen, setIsOriginalLanguageOpen] = useState(false);
  const [isRatingOpen, setIsRatingOpen] = useState(false);
  const [isOriginOpen, setIsOriginOpen] = useState(false);
  const divRefs = useRef({});
  const containerRef = useRef();

  useEffect(() => {
      // Scroll to the active div on page load
      const activeItem = programVideos.find(item => videodata?.filename === item?.filename);
      const container = containerRef.current;
      const activeEl = divRefs.current[activeItem?.id];
      if (container && activeEl) {
      const containerHeight = container.offsetHeight;
      const elementTop = activeEl.offsetTop;
      const elementHeight = activeEl.offsetHeight;

      const scrollTop =
        elementTop - containerHeight / 2 + elementHeight / 2 - 100; // 100px shift upward

      container.scrollTo({
        top: scrollTop,
        behavior: "smooth",
      });
    }
      
    }, []);

  // Refs for dropdowns to handle click outside
  const contentGroupRef = useRef(null);
  const originalLanguageRef = useRef(null);
  const ratingRef = useRef(null);
  const originRef = useRef(null);

 const formatTime = (milliseconds) => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
};

const handlemetaData = (data)=>{
  setVideodata(data)
  appStore.setAssetSignledata(toJS(data))

}
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (contentGroupRef.current && !contentGroupRef.current.contains(event.target)) {
        setIsContentGroupOpen(false);
      }
      if (originalLanguageRef.current && !originalLanguageRef.current.contains(event.target)) {
        setIsOriginalLanguageOpen(false);
      }
      if (ratingRef.current && !ratingRef.current.contains(event.target)) {
        setIsRatingOpen(false);
      }
      if (originRef.current && !originRef.current.contains(event.target)) {
        setIsOriginOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (videodata?.metadata) {
      const newMetadata = videodata?.metadata;
      setMetadata(newMetadata);
      setFeaturecheck(newMetadata?.featured == null ? false : newMetadata?.featured);
      setPartnerCode(newMetadata?.partnerCode);
      setPartnerName(newMetadata?.partnerName);
      setProgramId(newMetadata?.programId);
      setTitle(newMetadata?.title);
      setProgramType(newMetadata?.programType);
      setDuration(newMetadata?.duration);
      settranscodeduration(formatTime(videodata?.duration));
      setShortSynopsis(newMetadata?.shortSynopsis);
      setActors(newMetadata?.actors);
      setDirectors(newMetadata?.directors);
      setOriginalLanguage(newMetadata?.originalLanguage);
      setOrigin(newMetadata?.origin);
      let rate = newMetadata?.ratings[0]?.id;
      setRating(rate);
      setRatingsDescriptor(newMetadata?.ratingsDescriptor);
      const end = parseInt(newMetadata?.endDate, 10);
      const timestamp = parseInt(newMetadata?.startDate, 10);
      const startdate = !isNaN(timestamp) ? new Date(timestamp) : null;
      const enddate = !isNaN(end) ? new Date(end) : null;
      const redate = parseInt(newMetadata?.releaseDate, 10);
      const daterelease = !isNaN(redate) ? new Date(redate) : null;
      setReleaseDate(daterelease);
      setStartDate(startdate);
      setEndDate(enddate);
      setContentGroup(newMetadata?.contentGroup);
      setSelectedThemeIds(newMetadata?.themes.map((obj) => obj.id));
      setSelectedCategoryIds(newMetadata?.categories?.map((obj) => obj.id));
      setSelectedLanguageIds(newMetadata?.audioLanguages?.map((obj) => obj.id));
      setSelectedGenreIds(newMetadata?.genres?.map((obj) => obj.id));
      setSelectedTerritoryIds(newMetadata?.territories?.map(obj => obj.id));
    } else {
      setMetadata("");
      setPartnerCode("");
      setPartnerName("");
      setProgramId("");
      setTitle("");
      setProgramType("");
      setDuration("");
      settranscodeduration("");
      setShortSynopsis("");
      setActors("");
      setDirectors("");
      setReleaseDate();
      setOriginalLanguage("");
      setOrigin("");
      setRating([]);
      setRatingsDescriptor("");
      setFeaturecheck(null);
      setStartDate(null);
      setEndDate(null);
      setContentGroup();
      setSelectedThemeIds([]);
      setSelectedCategoryIds([]);
      setSelectedLanguageIds([]);
      setSelectedGenreIds([]);
      setSelectedTerritoryIds([]);
    }
  }, [videodata]);

  const [updatebtn, setupdatebtn] = useState(false);
  const [partnerCode, setPartnerCode] = useState("");
  const [partnerName, setPartnerName] = useState("");
  const [programId, setProgramId] = useState("");
  const [title, setTitle] = useState("");
  const [programType, setProgramType] = useState("");
  const [duration, setDuration] = useState("");
  const [shortSynopsis, setShortSynopsis] = useState("");
  const [actors, setActors] = useState("");
  const [directors, setDirectors] = useState("");
  const [releaseDate, setReleaseDate] = useState("");
  const [originalLanguage, setOriginalLanguage] = useState();
  const [origin, setOrigin] = useState("");
  const [rating, setRating] = useState("");
  const [ratingsDescriptor, setRatingsDescriptor] = useState();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [contentGroup, setContentGroup] = useState("");
  const [featurecheck, setFeaturecheck] = useState(false);
  const [transcodeduration, settranscodeduration] = useState("");

  const featuredchecks = () => {
    setFeaturecheck(!featurecheck);
  };

  const handleDoneClick = () => {
    const data = {
      title,
      programType,
      duration,
      shortSynopsis,
    };
    updatemetadata(videodata?.metadata?.id);
  };

  const formatReleaseDate = () => {
    const date = new Date(releaseDate);
    return `${date.getFullYear()}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
  };

  const updatemetadata = async (id) => {
    setupdatebtn(true);
    let data = {
      ...(videodata?.metadata == null && {
        "programId": videodata?.filename,
        "partnerId": AssetPartnerDetail?.id,
      }),
      "title": title,
      "programType": programType,
      "duration": duration,
      "shortSynopsis": shortSynopsis,
      "actors": actors,
      "directors": directors,
      "originalLanguage": originalLanguage,
      "origin": origin,
      "ratingIds": rating == null ? [] : [rating],
      "ratingsDescriptor": ratingsDescriptor,
      "territoryIds": selectedTerritoryIds,
      "startDate": startDate == null ? "" : new Date(startDate).getTime(),
      "endDate": endDate == null ? "" : new Date(endDate).getTime(),
      "releaseDate": releaseDate == null ? null : formatReleaseDate(),
      "audioLanguageIds": selectedLanguageIds,
      "themeIds": selectedThemeIds,
      "categoryIds": selectedCategoryIds,
      "genreIds": selectedGenreIds,
      "contentGroup": contentGroup,
      "featured": featurecheck,
    };

    if (title != "") {
      if (videodata?.metadata != null) {
        const metadata = await Metadataupdate(id, data);
        if (metadata?.data.status == true) {
          toast.success("Metadata updated successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        } else {
          toast.error("Something went wrong, please try after sometime", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      } else {
        const addmetadata = await MetadataAdd(data);
        if (addmetadata?.data.status == true) {
          toast.success("Metadata added successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        } else {
          toast.error("Something went wrong, please try after sometime", {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      }
      setupdatebtn(false);
      assetdetail();
    } else {
      toast.error("Title is required", {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
      setupdatebtn(false);
    }
  };

  useEffect(() => {
    getPartnerList();
    setGenreList(genre);
    setLanguageList(language);
    setCategoryOption(Category);
    setThemeList(Themes);
    setRatingList(Ratings);
    setTerritoryOption(Territorys);
  }, []);

  const getPartnerList = async () => {
    const partnerData = await Partner_list();
    if (partnerData?.data && partnerData?.status === true) {
      setPartnerOptions(partnerData.data);
    }
  };

  const validateValue = (value) => {
    if (value == '' || value == null || value.length === 0) {
      return 'Field is Required';
    } else {
      return '';
    }
  };

  return (
    <div className="dashboard-content row">
       <div className="top-content">
          <div className="left-side">
                

            <div className="breadcrumbs">
              <ul>
                <li>
                  <Link to="/asset">Asset Management</Link>
                </li>

                <li>
                  <a href="/CmsChannelDetail">{AssetPartnerDetail?.name}</a>
                </li>
                <li className="active">MetaData</li></ul>
            </div>
          </div>
          

        </div>

      <div className='col-10 metadataContent'>
        <div className="video-container my-3">
          <div className="video-title">
            {videodata?.metadata == null ? videodata?.filename : videodata?.metadata?.title}
            <span className="small-grey-text">
              {videodata?.metadata == null ? null : "(" + videodata?.filename + ")"}
            </span>
          </div>
          <button className="image-container" style={{ marginLeft: "auto" }} onClick={featuredchecks}>
            <img src={featurecheck ? check : uncheck} className="image" />
          </button>
          <button className="image-container" onClick={closepartition}>
            <img src={expand} className="image" />
          </button>
        </div>
        <div className='scroll-height'>
          <div className="expand-content w-100 row p-3">
            <div className="detail-row col-6">
              <div className="detail-label">Title<span style={{ color: "red" }}>*</span></div>
              <input
                className="detail-inputs"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Program Type</div>
              <input
                className="detail-inputs"
                value={programType}
                onChange={(e) => setProgramType(e.target.value)}
              />
            </div>
            {/* <div className="detail-row col-6">
              <div className="detail-label">Duration</div>
              <input
                className="detail-inputs"
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
              />
            </div> */}
            <div className="detail-row col-6">
  <div className="detail-label">Duration</div>
  {/* <input
    className="detail-inputs"
    type="text" // Use text to allow custom formatting
    value={duration}
    onChange={(e) => {
      let value = e.target.value;
      // Remove any non-numeric or non-colon characters
     value = value.replace(/[^0-9:]/g, '');
      // Enforce HH:MM:SS format
      if (value.length <= 8) { // Max length for HH:MM:SS
        // Format the input as the user types
        let formattedValue = value;
        if (value.length > 2 && value[2] !== ':') {
          formattedValue = value.slice(0, 2) + ':' + value.slice(2);
        }
        if (value.length > 5 && value[5] !== ':') {
          formattedValue = formattedValue.slice(0, 5) + ':' + formattedValue.slice(5);
        }
        // Validate the format
        if (formattedValue === '' || /^(\d{0,2}(:\d{0,2}(:\d{0,2})?)?)?$/.test(formattedValue)) {
          setDuration(formattedValue);
        }
      }
    }}
    placeholder="HH:MM:SS" // Guide the user
    maxLength={8} // Max length for HH:MM:SS
  /> */}
  <TimePicker 
        className="detail-inputs duration"
        value={duration}
        // disabled={editable}
        hourPlaceholder="HH"
        minutePlaceholder="MM"
        secondPlaceholder="SS"
        maxDetail="second"
        minTime="00:00:00"
        format="HH:mm:ss"
        onChange={(e) => {
           setDuration(e)
        }}
        disableClock={true}
    />
</div>
            <div className="detail-row col-6">
              <div className="detail-label">Transcoded Duration</div>
              <input
                disabled
                className="detail-inputs"
                value={transcodeduration}
                onChange={(e) => settranscodeduration(e.target.value)}
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Release Date</div>
              <DatePicker
                className="detail-inputs"
                selected={releaseDate || null}
                onChange={(date) => setReleaseDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy"
                isClearable
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Content Group</div>
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  background: 'transparent',
                }}
                ref={contentGroupRef}
              >
                <div
                  onClick={() => setIsContentGroupOpen(!isContentGroupOpen)}
                  style={{
                   width: '100%',
                    padding: '13px',
                    color: '#fff',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '1px solid #1c1c1c',
                    background: '#1c1c1c',
                    fontSize:"16px",
                  }}
                >
                  <span>{contentGroup || 'Select Content Group'}</span>
                  <span style={{ marginRight: '5px' }}>
                    <img src={dropdownArrow} alt="Dropdown" />
                  </span>
                </div>
                {isContentGroupOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      background: '#2E3033',
                      // border: '1px solid #444',
                      borderRadius: '0px 0px 4px 4px',
                      // marginTop: '2px',
                      zIndex: 10,
                      maxHeight: '200px',
                      overflowY: 'auto',
                       
                    }}
                    className='dropdownScroll'
                  >
                    {ContentGroup?.map((item) => {
                      const isSelected = contentGroup === item;
                      return (
                        <label
                          key={item}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '5px 10px',
                            color: '#fff',
                            cursor: 'pointer',
                            // borderBottom: '1px solid #444',
                            background: 'transparent',
                            fontSize:"16px",

                          }}
                          onClick={() => {
                            setContentGroup(item);
                            setIsContentGroupOpen(false);
                          }}
                        >
                          <div
                            style={{
                              width: '14px',
                              height: '15px',
                              borderRadius: '50%',
                              border: `2px solid ${isSelected ? '#E9E9E9' : '#606264'}`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '8px',
                              

                            }}
                          >
                            {isSelected && (
                              <div
                                style={{
                                  width: '7px',
                                  height: '7px',
                                  borderRadius: '50%',
                                  backgroundColor: '#E9E9E9',
                                }}
                              />
                            )}
                          </div>
                          {item}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Start Date</div>
              <DatePicker
                className="detail-inputs"
                selected={startDate || null}
                onChange={(date) => setStartDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy"
                isClearable
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">End Date</div>
              <DatePicker
                className="detail-inputs"
                selected={endDate || null}
                onChange={(date) => setEndDate(date)}
                dateFormat="dd/MM/yyyy"
                placeholderText="dd/mm/yyyy"
                isClearable
                minDate={startDate}
                disabled={!startDate}
              />
            </div>
            <div className="detail-row col-4">
              <div className="detail-label">Genres</div>
              <DynamicMultiSelect
                options={gernreList}
                displayValue="name"
                selectedValues={selectedGenreIds}
                placeholder="Select Genre"
                setSelectedCategoryIds={setSelectedGenreIds}
                selectedCategoryIds={selectedGenreIds}
              />
            </div>
            <div className="detail-row col-4">
              <div className="detail-label">Themes</div>
              <DynamicMultiSelect
                options={themeList}
                displayValue="name"
                selectedValues={selectedThemeIds}
                placeholder="Select Theme"
                setSelectedCategoryIds={setSelectedThemeIds}
                selectedCategoryIds={selectedThemeIds}
              />
            </div>
            <div className="detail-row col-4">
              <div className="detail-label">Categories</div>
              <DynamicMultiSelect
                options={categoryOptions}
                displayValue="name"
                selectedValues={selectedCategoryIds}
                placeholder="Select Categories"
                setSelectedCategoryIds={setSelectedCategoryIds}
                selectedCategoryIds={selectedCategoryIds}
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Original Language</div>
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  background: 'transparent',
                }}
                ref={originalLanguageRef}
              >
                <div
                  onClick={() => setIsOriginalLanguageOpen(!isOriginalLanguageOpen)}
                  style={{
                    width: '100%',
                    padding: '13px',
                    color: '#fff',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '1px solid #1c1c1c',
                    background: '#1c1c1c',
                    fontSize:"16px",
                  }}

                >
                  <span>
                    {languageList.find((item) => item.id === originalLanguage)?.name || 'Select Language'}
                  </span>
                  <span style={{ marginRight: '5px' }}>
                    <img src={dropdownArrow} alt="Dropdown" />
                  </span>
                </div>
                {isOriginalLanguageOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                     background: '#2E3033',
                      // border: '1px solid #444',
                      borderRadius: '0px 0px 4px 4px',
                      // marginTop: '2px',
                      zIndex: 10,
                      maxHeight: '200px',
                      overflowY: 'auto',
                       
                    }}
                    className='dropdownScroll'
                  >
                    {languageList?.map((item) => {
                      const isSelected = originalLanguage === item.id;
                      return (
                        <label
                          key={item.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '5px 10px',
                            color: '#fff',
                            cursor: 'pointer',
                            // borderBottom: '1px solid #444',
                            background: 'transparent',
                            fontSize:"16px",
                          }}
                          onClick={() => {
                            setOriginalLanguage(item.id);
                            setIsOriginalLanguageOpen(false);
                          }}
                        >
                          <div
                            style={{
                              width: '14px',
                              height: '14px',
                              borderRadius: '50%',
                              border: `2px solid ${isSelected ? '#E9E9E9' : '#606264'}`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '8px',
                            }}
                          >
                            {isSelected && (
                              <div
                                style={{
                                  width: '6px',
                                  height: '6px',
                                  borderRadius: '50%',
                                  backgroundColor: '#E9E9E9',
                                }}
                              />
                            )}
                          </div>
                          {item.name}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Audio Languages</div>
              <DynamicMultiSelect
                options={languageList}
                displayValue="name"
                selectedValues={selectedLanguageIds}
                placeholder="Select Language"
                setSelectedCategoryIds={setSelectedLanguageIds}
                selectedCategoryIds={selectedLanguageIds}
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Rating</div>
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  background: 'transparent',
                }}
                ref={ratingRef}
              >
                <div
                  onClick={() => setIsRatingOpen(!isRatingOpen)}
                  style={{
                    width: '100%',
                    padding: '13px',
                    color: '#fff',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '1px solid #1c1c1c',
                    background: '#1c1c1c',
                    fontSize:"16px",
                  }}
                >
                  <span>
                    {ratingList.find((item) => item.id === rating)?.name || 'Select Rating'}
                  </span>
                  <span style={{ marginRight: '5px' }}>
                    <img src={dropdownArrow} alt="Dropdown" />
                  </span>
                </div>
                {isRatingOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                     background: '#2E3033',
                      // border: '1px solid #444',
                      borderRadius: '0px 0px 4px 4px',
                      // marginTop: '2px',
                      zIndex: 10,
                      maxHeight: '200px',
                      overflowY: 'auto',
                       
                    }}
                    className='dropdownScroll'
                  >
                    {ratingList?.map((item) => {
                      const isSelected = rating === item.id;
                      return (
                        <label
                          key={item.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '5px 10px',
                            color: '#fff',
                            cursor: 'pointer',
                            // borderBottom: '1px solid #444',
                            background: 'transparent',
                            fontSize:"16px",
                          }}
                          onClick={() => {
                            setRating(item.id);
                            setIsRatingOpen(false);
                          }}
                        >
                          <div
                            style={{
                              width: '14px',
                              height: '14px',
                              borderRadius: '50%',
                              border: `2px solid ${isSelected ? '#E9E9E9' : '#606264'}`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '8px',
                            }}
                          >
                            {isSelected && (
                              <div
                                style={{
                                  width: '6px',
                                  height: '6px',
                                  borderRadius: '50%',
                                  backgroundColor: '#E9E9E9',
                                }}
                              />
                            )}
                          </div>
                          {item.name}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Ratings Descriptor</div>
              <input
                className="detail-inputs"
                value={ratingsDescriptor}
                onChange={(e) => setRatingsDescriptor(e.target.value)}
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Origin</div>
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  background: 'transparent',
                }}
                ref={originRef}
              >
                <div
                  onClick={() => setIsOriginOpen(!isOriginOpen)}
                  style={{
                   width: '100%',
                    padding: '13px',
                    color: '#fff',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '1px solid #1c1c1c',
                    background: '#1c1c1c',
                    fontSize:"16px",
                  }}
                >
                  <span>
                    {territoryOption.find((item) => item.niceName === origin)?.niceName || 'Select Origin'}
                  </span>
                  <span style={{ marginRight: '5px' }}>
                    <img src={dropdownArrow} alt="Dropdown" />
                  </span>
                </div>
                {isOriginOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      background: '#2E3033',
                      // border: '1px solid #444',
                      borderRadius: '0px 0px 4px 4px',
                      // marginTop: '2px',
                      zIndex: 10,
                      maxHeight: '200px',
                      overflowY: 'auto',
                       
                    }}
                    className='dropdownScroll'
                  >
                    {territoryOption?.map((item) => {
                      const isSelected = origin === item.niceName;
                      return (
                        <label
                          key={item.id}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: '5px 10px',
                            color: '#fff',
                            cursor: 'pointer',
                             // borderBottom: '1px solid #444',
                            background: 'transparent',
                            fontSize:"16px",
                          }}
                          onClick={() => {
                            setOrigin(item.niceName);
                            setIsOriginOpen(false);
                          }}
                        >
                          <div
                            style={{
                              width: '14px',
                              height: '14px',
                              borderRadius: '50%',
                              border: `2px solid ${isSelected ? '#E9E9E9' : '#606264'}`,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '8px',
                            }}
                          >
                            {isSelected && (
                              <div
                                style={{
                                  width: '6px',
                                  height: '6px',
                                  borderRadius: '50%',
                                  backgroundColor: '#E9E9E9',
                                }}
                              />
                            )}
                          </div>
                          {item.niceName}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Territory</div>
              <DynamicMultiSelect
                options={territoryOption}
                displayValue="niceName"
                selectedValues={selectedTerritoryIds}
                placeholder="Select Territory"
                setSelectedCategoryIds={setSelectedTerritoryIds}
                selectedCategoryIds={selectedTerritoryIds}
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Actors</div>
              <input
                className="detail-inputs"
                value={actors}
                onChange={(e) => setActors(e.target.value)}
              />
            </div>
            <div className="detail-row col-6">
              <div className="detail-label">Directors</div>
              <input
                className="detail-inputs"
                value={directors}
                onChange={(e) => setDirectors(e.target.value)}
              />
            </div>
            <div className="detail-row col-12">
              <div className="detail-label">Short Synopsis</div>
              <textarea
                className="detail-inputs"
                value={shortSynopsis}
                onChange={(e) => setShortSynopsis(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
      <div className='col-2 metaVideoDta'>
        <div className='right-bar'>
          <div>
            <div><h3 className='text-center right-head'> Videos </h3></div>
            <div className='video-channel-list meta scroll-height' ref={containerRef}>
              {programVideos &&
                programVideos.map((data, index) => {
                  let image = posterimage(data);
                  return (
                   <div className={`${videodata?.filename === data?.filename ? 'selected-block' : ""} block m-auto my-2`} onClick={() => {handlemetaData(data)}} key={index}
                    ref={el => (divRefs.current[data.id] = el)}
                    >
                        {image === "" ? (
                          <div className="img-block" style={{ overflow: "hidden", width: "100%" }}>
                            <img src={Groupicon} alt="" />
                          </div>
                        ) : (
                          <div className="img-block p-0" style={{ overflow: "hidden" }}>
                            <img style={{ width: "100%", height: "auto" }} src={image} alt="" />
                          </div>
                        )}
                        <div className="text-block">
                          <label>
                            {data?.metadata == null ? data.filename : data?.metadata?.title == null ? data.filename : data?.metadata?.title}
                          </label>
                        </div>
                      </div>
                  );
                })}
             
            </div>
          </div>
        </div>
      </div>
      <div className='footerButtons'>
        <button className='default-odd' onClick={closepartition}>Cancel</button>
        <button disabled={updatebtn} className='default-even mx-3' onClick={handleDoneClick}>
          {videodata?.metadata != null ? "Update" : "Add"}
        </button>
      </div>
    </div>
  );
}
)
export default MetaDataView;